"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGuestInfoUpdatedMockData = exports.buildGuestTicketMockData = void 0;
const enums_1 = require("../../enums");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const buildGuestBranding = ({ color, isDarkMode, locale = "en" }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return { theme, iconZeffyLogo, labels: (0, email_templates_1.getEmailLabels)(locale), lang: locale };
};
const buildGuestTicketMockData = ({ orgName, color, isDarkMode, locale = "en", formCategory = enums_1.TicketingFormCategory.Event, firstName = "John", buyerName = "Jordan Lee", campaignName = "Annual Charity Gala", campaignDateTime = "Saturday, June 6, 2026, 6:00 PM EDT", campaignAddress = "123 Kindness Ave, Montreal, QC", ticketsUrl = "https://www.zeffy.com/tickets", }) => ({
    ...buildGuestBranding({ orgName, color, isDarkMode, locale }),
    isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
    orgName: orgName || "Bright Futures Foundation",
    firstName,
    buyerName,
    campaignName,
    campaignDateTime,
    campaignAddress,
    ticketsUrl,
});
exports.buildGuestTicketMockData = buildGuestTicketMockData;
const buildGuestInfoUpdatedMockData = ({ orgName, color, isDarkMode, locale = "en", formCategory = enums_1.TicketingFormCategory.Event, firstName = "Jordan", campaignName = "Annual Charity Gala", guestName = "John Smith", guestEmail = "john@example.com", ticketsUrl = "https://www.zeffy.com/tickets", }) => ({
    ...buildGuestBranding({ orgName, color, isDarkMode, locale }),
    isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
    orgName: orgName || "Bright Futures Foundation",
    firstName,
    campaignName,
    guestName,
    guestEmail,
    ticketsUrl,
});
exports.buildGuestInfoUpdatedMockData = buildGuestInfoUpdatedMockData;
